import { Button } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import React, { Component } from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";
import { getPricingPageUrl } from "js/core/utilities/pricing";
import { app } from "js/namespaces";
import BeautifulDialog from "js/react/components/Dialogs/BeautifulDialog";
import { Gap20, Gap50 } from "js/react/components/Gap";
import { dialogTheme } from "js/react/materialThemeOverrides";

const StyledHeader = styled.div`
    display: flex;
    gap: 12px;
`;

const WarningText = styled.div`
        color: orangered;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        text-align: center;
`;

const HeaderText = styled.div`
    font-size: 25px;
    font-weight: 600;
`;

const FeaturesWrapper = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 480px) {
        flex-direction: column;
    }

`;

const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
`;

const Feature = styled.div`
    display:flex;
    gap: 17px;
    font-size: 16px;
    line-height: 20px;
`;

const LearnMore = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: .5px;
    color: #666;

    a {
        color: #11A9E2
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    gap: 30px;
    justify-content: end;
`;

const UpgradePlanDialog = styled.div`
    font-family: "Source Sans Pro";
    color: #333;
    background: white;
    min-height: fit-content;
    overflow-y: auto;
    padding: 40px 50px;
`;

export class ForcedDowngradeDialog extends Component {
    render() {
        const { closeDialog } = this.props;

        return (
            <MuiThemeProvider theme={dialogTheme}>
                <BeautifulDialog maxWidth="md" fullWidth={false} closeDialog={closeDialog}>
                    <UpgradePlanDialog>
                        <StyledHeader>
                            <img src={getStaticUrl("/images/billing/warning.svg")} />
                            <WarningText >
                                Your trial or subscription has ended
                            </WarningText>
                        </StyledHeader>
                        <Gap20 />

                        <HeaderText>
                            Renew your subscription to continue to enjoy Beautiful.ai Pro features, including:
                        </HeaderText>
                        <Gap50 />
                        <FeaturesWrapper>
                            <FeatureWrapper>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>All Generative AI Features</span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>Slides Without Watermarks</span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>
                                        Custom Fonts</span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>Folders</span>
                                </Feature>
                            </FeatureWrapper>
                            <FeatureWrapper>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>
                                        Revision History
                                    </span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>Secure Sharing</span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>Presentation Analytics</span>
                                </Feature>
                                <Feature>
                                    <img src={getStaticUrl("/images/check.svg")} />
                                    <span>Offline Player</span>
                                </Feature>
                            </FeatureWrapper>
                        </FeaturesWrapper>
                        <Gap50 />
                        <LearnMore>
                            Learn more about our plans  <a
                                href={getPricingPageUrl(app && app.user.hasTakenTrial, app && app.user.has("hasTakenTeamTrial"), "basic")}
                                rel="noreferer, ,noopener"
                                target="_blank"
                            >
                                here
                            </a>.
                        </LearnMore>
                        <Gap20 />
                        <ButtonWrapper>
                            <Button variant="text" style={{
                                color: "#666"
                            }} onClick={closeDialog}>Dismiss</Button>
                            <Button color="primary" onClick={() => {
                                window.location.href = `${window.location.origin}/checkout`;
                            }}>Renew Now</Button>
                        </ButtonWrapper>
                    </UpgradePlanDialog>
                </BeautifulDialog>
            </MuiThemeProvider>
        );
    }
}
